import React from "react";
import styled from "styled-components";
import QRCodeComponent from "qrcode.react";
import Avatar from "../../common/Avatar";
import useUser from "../../../../framework/connectors/user/useUser";
import useAsyncAppUrl from "./useAsyncAppUrl";
import { cloud } from "@vitalsource/vstui/colors";
import { Button } from "@vitalsource/vstui";
import { StartOver } from "@vitalsource/vstui-icons";
import AvatarBackground from "./QRAvatarBackground.png";
import { FormattedMessage, useIntl } from "react-intl";

const Styled = {
  CodeContainer: styled.div`
    position: relative;
    height: 290px;
    width: 308px;
    border: 1px solid ${cloud.getShade(4)};
    border-radius: 4px;
  `,

  QRCodeComponent: styled(QRCodeComponent)`
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 50%;
  `,
  QRAvatar: styled(Avatar)`
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  `,
  RefreshButton: styled(Button)<{
    show: boolean;
  }>`
    display: ${({ show }) => (show ? "block" : "none")};
    position: relative;
    margin: auto;
    top: calc(50% - 20px);
    z-index: 2;
    background-color: white !important;
    &:hover,
    &:active {
      background-color: white !important;
    }
  `,
};

interface Props {
  className?: string;
}

const QRCode: React.FC<Props> = ({ className }) => {
  const { isReferenceUser, userInfo } = useUser();
  const {
    appUrl,
    fetchUrl,
    autoRefreshDisabled,
    isCodeExpired,
  } = useAsyncAppUrl();
  const intl = useIntl();

  if (!appUrl) {
    return null;
  }

  return (
    <div className={className}>
      <Styled.CodeContainer>
        <Styled.QRAvatar
          initials={!isReferenceUser && userInfo.firstName?.[0]}
        />
        <Styled.QRCodeComponent
          size={256}
          value={appUrl}
          level={"Q"}
          renderAs={"png"}
          role="img"
          aria-label={intl.formatMessage({ id: "QRDownloadApps.codeAltText" })}
          imageSettings={{
            src: AvatarBackground,
            x: null,
            y: null,
            height: 80,
            width: 80,
            excavate: false,
          }}
        />
        <Styled.RefreshButton
          iconStart={<StartOver />}
          pill
          outline
          onClick={fetchUrl}
          show={isCodeExpired && autoRefreshDisabled}
        >
          <FormattedMessage id={"base.refresh"} />
        </Styled.RefreshButton>
      </Styled.CodeContainer>
    </div>
  );
};

export default QRCode;
